'use strict'
var video = angular.module('videoModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
	'ui.tinymce',
	'thatisuday.dropzone'	
]);

require('./video/js/directive/allVideosDirective.js')(video);
require('./video/js/allVideosController.js')(video);
require('./new-video/js/directive/newVideoDirective.js')(video);
require('./new-video/js/newVideoController.js')(video);
require('./new-video/js/directive/newVideoMediaoutcastDirective.js')(video);
require('./new-video/js/newVideoMediaoutcastController.js')(video);
require('./new-video/js/directive/uppyDashboardDirective.js')(video);
require('./video/js/directive/videoEditDirective.js')(video);
require('./video-categories/js/directive/videoCategoriesDirective.js')(video);
require('./video-categories/js/videoCategoriesController.js')(video);

require('./video-tags/js/directive/videoTagsDirective.js')(video);
require('./video-tags/js/videoTagsController.js')(video);

require('./video-category-edit/js/directive/videoCategoryEditDirective.js')(video);
require('./video-category-edit/js/videoCategoryEditController.js')(video);

require('./video-tag-edit/js/directive/videoTagEditDirective.js')(video);
require('./video-tag-edit/js/videoTagEditController.js')(video);
require('./setFeaturedVideoDirective.js')(video);

require('./livestream/js/directive/livestreamDirective.js')(video);
require('./livestream/js/livestreamController.js')(video);
require('./related-video-box/js/directive/relatedVideoBoxDirective.js')(video);
require('./related-video-box/js/relatedVideoBoxController.js')(video);


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/videoModule.js
// module id = 658
// module chunks = 0